<template>
	<div class="not-found">
		没有当前页面！
	</div>
</template>

<script>
	export default {
		
	}
</script>

<style scoped>

</style>